import { Checkbox } from '@mui/material';
import { styled } from '@mui/system';

export const ACheckbox = styled(Checkbox)(({ theme }) => ({
    color: '#02584B',
    '&.Mui-checked': {
        color: '#02584B',
    },
}));
